"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStateBody = void 0;
const getStateBody = () => {
    const slug = localStorage.getItem('re');
    const isCatalogGeneric = process.env.GENERIC_URL === slug;
    let state = {};
    if (isCatalogGeneric) {
        state = { state: localStorage.state };
    }
    return state;
};
exports.getStateBody = getStateBody;
